<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .tab-content {
    background-color: colors.get(interfaceWhite);
    border-radius: 0 utils.in_rem(10px) utils.in_rem(10px) utils.in_rem(10px);
    padding: utils.in_rem(16px) utils.in_rem(16px) utils.in_rem(20px)
      utils.in_rem(16px);

    &.full-page {
      border-radius: 0 0 utils.in_rem(10px) utils.in_rem(10px);
    }
  }
</style>

<script>
  import EmptyState from "./EmptyState.svelte";

  export let hasData = false;
  export let emptyMessage = "No data available.";
  export let tabCount = 0;
</script>

<div class={tabCount < 4 ? "tab-content" : "tab-content full-page"}>
  {#if hasData}
    <slot />
  {:else}
    <EmptyState message={emptyMessage} />
  {/if}
</div>
